import { render, staticRenderFns } from "./AuthorsList.vue?vue&type=template&id=6e27436b&scoped=true&"
import script from "./AuthorsList.vue?vue&type=script&lang=js&"
export * from "./AuthorsList.vue?vue&type=script&lang=js&"
import style0 from "./AuthorsList.vue?vue&type=style&index=0&id=6e27436b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e27436b",
  null
  
)

export default component.exports